import { render, staticRenderFns } from "./ClListItemSecondaryAction.html?vue&type=template&id=1060e5b2&"
import script from "./ClListItemSecondaryAction.ts?vue&type=script&lang=ts&"
export * from "./ClListItemSecondaryAction.ts?vue&type=script&lang=ts&"
import style0 from "./ClListItemSecondaryAction.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports